import captionAnimation from '../caption/index.animation';
export default {
  "initial.caption.subCaption": captionAnimation['initial.caption.caption']
};